import * as contentful from 'contentful';
import { Entry } from 'contentful';
import { AppSwitcherLink } from '../types/navigation.types';
import { getLocale } from '../../../util/locales/locales';
import { mapToStihlIdAppSwitcher } from './utils';

export const getStihlApps = async (locale: string): Promise<AppSwitcherLink[]> => {
  const client = contentful.createClient({
    space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE as string,
    environment: process.env.NEXT_PUBLIC_CONTENTFUL_ENV as string,
    accessToken: process.env.NEXT_PUBLIC_NAVIGATION_CONTENTFUL_API_TOKEN as string,
  });

  const links = await client.getEntries<AppSwitcherLink>({
    content_type: 'stihlApplication',
    locale: getLocale(locale).RFC5646,
  });

  const items: Entry<AppSwitcherLink>[] = [];

  for (const item of links.items) {
    if (!item?.fields?.displayName) {
      continue;
    }

    const currentItem: Entry<AppSwitcherLink> = { ...item, fields: { ...item.fields } };

    if (item?.fields?.icon?.sys?.id) {
      const response = await client.getAsset(item?.fields?.icon?.sys?.id);
      currentItem.fields['iconUrl'] = response?.fields?.file?.url;
    }

    items.push(currentItem);
  }

  return (
    items
      .filter((item) => item?.fields?.enabled)
      .map(mapToStihlIdAppSwitcher)
      .sort(({ order: orderA = 0 }, { order: orderB = 0 }) => orderA - orderB) || []
  );
};
